import React, { useMemo, Fragment, useEffect, useState, useRef, useContext } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router-dom";
import { MaterialReactTable } from 'material-react-table';
import { useOutletContext } from 'react-router-dom';

const ClientTeamDialog = ({ open, setOpen, clientTeamTableData, setClientTeamTableData, clientUserListFromAPI }) => {
    let navigate = useNavigate();
    const {refClientAccountCmsData}=useOutletContext();

    const tableInstanceRef = useRef(null);
    
  
    const fetchAccountTeamMemberCmsData = (key) => {
        if (refClientAccountCmsData?.Components && refClientAccountCmsData?.Components["ClientAccounts.ClientTeamMembers"]) {
            const adminClientSubAccountCmsDataLabel = refClientAccountCmsData?.Components["ClientAccounts.ClientTeamMembers"];
            return returnLabel(adminClientSubAccountCmsDataLabel?.Labels, key)
        }
        return '';
    }
    const fetchCommonComponentCMSLabel = (key) => {
        if (refClientAccountCmsData?.Components && refClientAccountCmsData?.Components["CommonComponent"]) {
            const commonComponentLabel = refClientAccountCmsData?.Components["CommonComponent"];
            return returnLabel(commonComponentLabel?.Labels, key)
        }
        return '';
    }
    const returnLabel = (labelArray = [], key) => {
        return labelArray.find((x) => x.Key === key)?.Phrase || '';
    }
   

    const columns = useMemo(
        () => [
            {
                accessorFn: (row) => `${row.FirstName} ${row.LastName}`,
                header: fetchAccountTeamMemberCmsData('ClientTeamMembers.Name'),
                muiTableHeadCellFilterTextFieldProps: { placeholder: fetchAccountTeamMemberCmsData("ClientTeamMembers.PlaceholderName") }
            },
            {
                accessorKey: "EmailAddress",
                header: fetchAccountTeamMemberCmsData('ClientTeamMembers.Email'),
                muiTableHeadCellFilterTextFieldProps: { placeholder: fetchAccountTeamMemberCmsData("ClientTeamMembers.PlaceholderEmail") }
            },
            {
                accessorKey: "JobRole",
                header: fetchAccountTeamMemberCmsData('ClientTeamMembers.JobRole'),
                muiTableHeadCellFilterTextFieldProps: { placeholder: fetchAccountTeamMemberCmsData("ClientTeamMembers.PlaceholderJobRole") }
            },
            {
                accessorFn: (row) => `${row.PermissionCode} - ${row.PermissionDescription}`,
                header: fetchAccountTeamMemberCmsData('ClientTeamMembers.PermissionLevel'),
                muiTableHeadCellFilterTextFieldProps: { placeholder: fetchAccountTeamMemberCmsData("ClientTeamMembers.PlaceholderPermissionLevel") }
            },
        ],
        []
    );

    /** */
    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick") {
            return '';
        } else {
            setOpen(false);
        }
        /**clear selections */
        setRowSelection({})
    }

    //optionally, you can manage the row selection state yourself
    const [rowSelection, setRowSelection] = useState({});

    const handleAddList = () => {
        /**get list of selected objects */
        const selectedRowObjList = tableInstanceRef.current
            .getSelectedRowModel()
            .rows.map((eachSelectedRowModel) => {
                return eachSelectedRowModel.original
            });
        setClientTeamTableData([...clientTeamTableData, ...selectedRowObjList])

        // console.log("gl-sub:", selectedRowObjList)
        handleClose()
    }

    /**getting Ids of all exisitng entries to disable their selection */
    const [existingIds, setExistingIds] = useState([])
    useEffect(() => {
        if (!!clientTeamTableData) {
            const list = clientTeamTableData.map((item) => {
                return item.Id
            })
            setExistingIds(list)
        }
    }, [clientTeamTableData])



    return (
        <Dialog
            open={open}
            onClose={handleClose}
            disableEscapeKeyDown
            fullScreen
        >
            <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
                {fetchAccountTeamMemberCmsData('ClientTeamMembers.ClientTeamMembers')}
                <IconButton
                    sx={{ ml: 'auto' }}
                    onClick={handleClose}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <MaterialReactTable
                    tableInstanceRef={tableInstanceRef}
                    columns={columns}
                    data={clientUserListFromAPI}
                    initialState={{
                        density: 'compact',
                        showColumnFilters: true
                    }}
                    // enableRowSelection
                    enableRowSelection={(row) => {
                        // console.log("roe", row.original)
                        return !existingIds.includes(row.original.Id)
                    }}
                    getRowId={(originalRow) => originalRow.Id}//give each row a more useful id
                    onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                    state={{ rowSelection }}
                    enableStickyHeader
                    muiTablePaginationProps={{
                        labelRowsPerPage: fetchCommonComponentCMSLabel('Common.Rowsperpage')
                    }}
                />

            </DialogContent>
            <DialogActions>
                <Button type='button' onClick={() => {
                    handleAddList()
                }}>{fetchCommonComponentCMSLabel('Common.Add')}</Button>
                <Button onClick={handleClose}>{fetchCommonComponentCMSLabel('Common.Cancel')}</Button>
            </DialogActions>

        </Dialog>
    )
}
export default ClientTeamDialog